import { z } from "zod"

export const openOceanQuoteResponse = z.object({
  code: z.number(),
  data: z
    .object({
      chainId: z.number().optional(),
      inToken: z.object({
        symbol: z.string(),
        name: z.string(),
        decimals: z.number(),
        address: z.string(),
      }),
      outToken: z.object({
        symbol: z.string(),
        name: z.string(),
        address: z.string(),
        decimals: z.number(),
      }),
      inAmount: z.string(),
      outAmount: z.string(),
      estimatedGas: z.number(),
      minOutAmount: z.string(),
      from: z.string(),
      to: z.string(),
      value: z.string(),
      gasPrice: z.string(),
      data: z.string(),
      gmxFee: z.number().optional(),
    })
    .optional(),
  message: z.string().optional(),
})

export type OpenOceanQuoteResponse = z.infer<typeof openOceanQuoteResponse>

export const openOceanGasPriceResponse = z.object({
  code: z.number(),
  data: z.object({
    standard: z.number(),
    fast: z.number(),
    instant: z.number(),
  }),
  without_decimals: z.object({
    standard: z.number(),
    fast: z.number(),
    instant: z.number(),
  }),
})

export type OpenOceanGasPriceResponse = z.infer<typeof openOceanGasPriceResponse>
